import { render, staticRenderFns } from "./ConsultaPlano.vue?vue&type=template&id=30e6bd3e&"
import script from "./ConsultaPlano.vue?vue&type=script&lang=js&"
export * from "./ConsultaPlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports